import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackRefundPageVisit } from './userJourneyTracker';

const sections = [
  {
    title: 'Subscription and Billing',
    body: 'Makereels.live offers both free and paid subscription plans, which may be billed on a recurring basis (such as monthly or yearly) in advance. By subscribing to a paid plan, you agree to provide valid and current payment information and authorize us, including through third-party payment processors, to charge applicable subscription fees at the beginning of each billing cycle and on each renewal date thereafter. Subscription fees, pricing, and plan features may vary and are subject to change at our discretion, as described in our Terms of Service.'
  },
  {
    title: 'Auto-Renewal and Cancellation',
    body: 'All paid subscriptions automatically renew at the end of the applicable billing period unless canceled prior to renewal. By purchasing a subscription, you acknowledge and agree to such recurring billing. You may cancel your subscription at any time through your account settings or designated billing section within the platform; however, cancellation will only take effect at the end of the current billing cycle, and access to paid features will continue until that time. Failure to cancel prior to renewal may result in continued billing for the next subscription period.'
  },
  {
    title: 'Fees and Changes',
    body: 'We reserve the right to modify subscription fees, introduce new charges, or change pricing structures at any time. Any such changes may take effect immediately or at the start of the next billing cycle, as applicable. Continued use of the Services following any pricing change constitutes your acceptance of the updated fees. It is your responsibility to review pricing updates and manage your subscription accordingly.'
  },
  {
    title: 'Refund Policy',
    body: 'All payments made for subscription plans are final and non-refundable, except where required by applicable law. This includes, without limitation, partial subscription periods, unused features, accidental usage, or failure to cancel prior to renewal. No refunds, credits, or prorated adjustments will be provided for any unused time, reduced usage, or early termination of a subscription. In cases where a user believes a payment has been made in error or without authorization, the user may contact us, and we may review such requests at our sole discretion; however, submission of a request does not guarantee any refund or reversal.'
  },
  {
    title: 'Fair Use and Abuse',
    body: 'Access to paid plans, including those described as "unlimited," remains subject to fair and reasonable use. We reserve the right to take appropriate action, including limiting usage, restricting access, or suspending accounts, without refund, where usage is determined to be excessive, abusive, automated beyond normal use, or otherwise inconsistent with the intended use of the Services. Any such determination shall be made at our sole discretion.'
  },
  {
    title: 'Payment Disputes and Chargebacks',
    body: 'In the event of a payment dispute, chargeback, or reversal initiated through your payment provider, we reserve the right to suspend or terminate your account and access to the Services immediately. We may also take further action as necessary to recover any outstanding amounts or associated costs incurred as a result of such disputes.'
  }
];

function RefundPage() {
  useEffect(() => {
    trackRefundPageVisit();
  }, []);

  const paragraphStyle = {
    margin: 0,
    lineHeight: 1.7,
    color: '#334155',
    textAlign: 'justify',
    fontFamily: "'Inter', sans-serif"
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: "'Inter', sans-serif", display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, padding: '48px 16px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', background: '#ffffff', borderRadius: '16px', padding: '40px 28px', boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)' }}>
        <h1 style={{ margin: 0, fontSize: '2.75rem', color: '#0f172a', textAlign: 'center', fontFamily: "'Montserrat', sans-serif" }}>Refund & Cancellation Policy</h1>
        <p style={{ marginTop: '12px', marginBottom: '24px', color: '#475569' }}>
          Effective Date: 19/03/2025
        </p>

        {sections.map((section) => (
          <section key={section.title} style={{ marginBottom: '28px' }}>
            <h2 style={{ marginBottom: '10px', fontSize: '1.2rem', color: '#1e293b', fontFamily: "'Montserrat', sans-serif" }}>{section.title}</h2>
            <p style={paragraphStyle}>{section.body}</p>
          </section>
        ))}

        <section>
          <h2 style={{ marginBottom: '10px', fontSize: '1.2rem', color: '#1e293b', fontFamily: "'Montserrat', sans-serif" }}>Contact</h2>
          <p style={paragraphStyle}>
            If you have any questions, concerns, or requests regarding Refunds & Cancellation, you may contact us at{' '}
            <a href="mailto:Aksharshare@gmail.com" style={{ color: '#5170ff', textDecoration: 'none' }}>Aksharshare@gmail.com</a>
            {' '}or via chat support.
          </p>
        </section>
        </div>
      </div>
      <footer className="footer">
        <div className="footer-content">
          <p className="footer-text">© 2026 Makereels.live. All rights reserved.</p>
          <nav className="footer-nav" aria-label="Legal">
            <Link to="/policy" className="footer-link">Privacy Policy</Link>
            <span className="footer-sep" aria-hidden="true">·</span>
            <Link to="/terms" className="footer-link">Terms of Service</Link>
            <span className="footer-sep" aria-hidden="true">·</span>
            <Link to="/refund" className="footer-link">Refund Policy</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export default RefundPage;
